module.exports = __webpack_public_path__ + "static/media/3.74320b9e.jpg";